export default "__VITE_ASSET__09ee414c__"